import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 10l-6 10l-3 -5l6 -10l3 5","key":"svg-0"}],["path",{"d":"M9 15h12l-3 5h-12","key":"svg-1"}],["path",{"d":"M15 15l-6 -10h6l6 10l-6 0","key":"svg-2"}]]

const IconBrandGoogleDrive = createReactComponent('outline', 'brand-google-drive', 'BrandGoogleDrive', __iconNode);

export default IconBrandGoogleDrive;